<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('licensing.noSeatCard.text.title') }}
    </template>

    <template #content>
      <div>
        <p>{{ $t('licensing.noSeatCard.text.main') }}</p>
        <p>
          <button @click="$emit('cancel')" class="license-no-seat-card__inline-button">
            {{ $t('licensing.action.limited') }}
          </button>
        </p>
      </div>
    </template>

    <template #footer>
      <LicenseUpgradeAction />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LicenseUpgradeAction from '@components/license/LicenseUpgradeAction.vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LicenseNoSeatCard',

  components: {
    LicenseUpgradeAction,
  },
});
</script>

<style lang="scss">
@use 'mixins/button';

.license-no-seat-card__inline-button {
  @include button.button-inline;
}
</style>
